/* DON'T EDIT THIS FILE: edit original and run build again */ export const canAccessMarketplace = "canAccessMarketplace";

export const canViewUsersInCounterpartiesLog =
  "canViewUsersInCounterpartiesLog";
export const canPublishInMarketplace = "canPublishInMarketplace";
export const canFilterLinesByAlyc = "canFilterLinesByAlyc";
// object permission
export const canRequestObjectPermission = "canRequestObjectPermission";
